// actions

// mutations
export const SET_DESIGNATOR_LIST = 'SET_DESIGNATOR_LIST'
export const SET_UNIQUE_DESIGNATOR_LIST = 'SET_UNIQUE_DESIGNATOR_LIST'
export const SET_DESIGNATOR = 'SET_DESIGNATOR'
// getters
